"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterBar = void 0;
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const text_field_1 = require("client/components/material/text-field");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./filter-bar.less");
const modal_1 = require("../../../client/components/modal");
const select_1 = require("../../../client/components/material/select");
const material_ui_1 = require("material-ui");
const store_1 = require("../../../client/modules/orders/store");
//C-045.1
const mobx_1 = require("mobx");
const store_2 = require("../../../client/modules/sites/modules/sites-list/store");
const store_3 = require("../../../client/modules/users/store");
const filter_1 = require("../../components/icons/filter"); //C-045.12
// C-045.1 C-045.11
const claimStatusOptions = [
    { id: 1, label: "Dispensed", value: "5dispensed" },
    { id: 2, label: "Ready for Provider Review", value: "3ready" },
    { id: 3, label: "Pending Adjudication", value: "4pending" },
    { id: 4, label: "Intend to Dispense", value: "9intended" },
    { id: 5, label: "In Progress", value: "8executing" },
    { id: 6, label: "Refill Due", value: "0refill" },
    { id: 7, label: "Error", value: "1error" },
].sort((a, b) => {
    if (a.label < b.label) {
        return -1;
    }
    return 0;
});
let FilterBar = class FilterBar extends react_1.Component {
    // C-045.2
    constructor(props) {
        super(props);
        // C-045.1
        this.filterText = "";
        this.filterDate = "";
        this.siteId = 0;
        this.startDate = "";
        this.endDate = "";
        this.cashClaimsOnly = false;
        this.showDisabledSites = false;
        this.claimStatus = "";
        this.filteredClaimsOrder = [];
        this.orderClaimsRow = [];
        // C-045.1
        this.handleChangeClaimStatus = (value) => {
            this.claimStatus = value;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleSubmitQuery = () => {
            var _a;
            if (this.startDate === "" || this.endDate === "" || this.claimStatus === "")
                return alert("Please fill all fields ");
            this.filteredClaimsOrder = (_a = store_1.ordersStore.orders) === null || _a === void 0 ? void 0 : _a.value.filter((order) => {
                const startDate = moment(order.createDate).format("YYYY-MM-DD");
                const endDate = moment(order.createDate).format("YYYY-MM-DD");
                return (String(startDate) >= this.startDate && String(endDate) <= this.endDate) &&
                    this.siteId === 0
                    ? (this.claimStatus == "8executing" ? ("8executing" === order.status || "7progress" === order.status) : this.claimStatus === order.status)
                    : ((order.site.id === this.siteId && (this.claimStatus == "8executing" ? ("8executing" === order.status || "7progress" === order.status) : this.claimStatus === order.status)));
            });
            store_1.ordersStore.setClaimOrders(this.filteredClaimsOrder);
            if (this.filteredClaimsOrder) {
                this.handleCancel();
            }
        };
        this.handleClearFilter = () => {
            store_1.ordersStore.setClaimOrdersStatus(false);
        };
        this.handleSearch = (event, value) => {
            this.props.callBack(value, this.props.filterDate || "");
        };
        this.handleDatePickerChange = (value) => {
            if (typeof value === "string") {
                this.props.callBack(this.props.filterText || "", value);
            }
            else {
                // @tkay added else statement. If this breaks you know who to blame.
                const dateToString = moment(value).format("MM/DD/YYYY");
                this.props.callBack(this.props.filterText || "", dateToString);
            }
        };
        this.handleClickToday = () => {
            this.props.callBack(this.props.filterText || "", new Date().toDateString());
        };
        //  C-045.2
        this.filterClick = () => {
            this.setState({ isFilterPopup: true });
        };
        // C-045.1
        this.handleCancel = () => {
            this.setState({ isFilterPopup: false });
            // this.siteId = 0;
            // this.claimStatus = "";
            // this.startDate = "";
            // this.endDate = "";
        };
        this.headerToggle = () => {
            this.setState({ isFilterPopup: !this.state.isFilterPopup });
        };
        this.handleClickClear = () => {
            this.props.callBack("", "");
        };
        this.state = {
            isFilterPopup: false,
        };
    }
    // C-045.1
    get availableOptions() {
        var _a;
        const options = [];
        const isImbUser = store_3.usersStore.user.value.user;
        if (isImbUser) {
            if (store_2.sitesListStore.sites.value) {
                options.push({ id: 0, label: "All Pharmacies", value: "0" });
                store_2.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString(),
                    });
                });
            }
        }
        else {
            const { site } = store_3.usersStore.user.value;
            const siteOption = {
                id: site.id,
                label: (_a = site.displayName) !== null && _a !== void 0 ? _a : site.name,
                value: site.id.toString(),
            };
            options.push(siteOption);
        }
        return options;
    }
    // end here
    render() {
        var _a;
        const { label = "Search", title, withDatePicker, countFilter, hideAdvancedFilter } = this.props;
        {
            /* C-045.2 */
        }
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { style: { color: "white" }, className: "btnCancel", onClick: this.handleCancel }, "Cancel"), React.createElement(button_1.MaterialButton, { className: "btnSubmit", onClick: this.handleSubmitQuery, primary: true, style: { marginLeft: "1em" } }, "Submit"));
        return (React.createElement("div", { className: "filter-bar" },
            this.state.isFilterPopup && !hideAdvancedFilter && (React.createElement(modal_1.Modal, { onCancel: this.headerToggle, height: "fit-content", top: "25%", width: "fit-content", buttons: buttons },
                React.createElement("div", { className: "filter-bar" },
                    React.createElement("div", { className: "" },
                        React.createElement("div", { className: "sites__data__disabled-toggle" }),
                        React.createElement("div", { style: { display: "flex" } },
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, style: { marginRight: "1em" }, value: String(this.siteId) || "", width: "100%" }),
                            React.createElement(select_1.MaterialSelect, { options: claimStatusOptions, required: true, searchable: true, label: "Claim Status *", onSelect: this.handleChangeClaimStatus, value: String(this.claimStatus) || "", width: "100%" }))),
                    React.createElement("div", { style: { display: "flex" } },
                        React.createElement("div", { className: "filter-bar", style: { paddingRight: "1em" } },
                            React.createElement("h3", null, "Start Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date *", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear"))),
                        withDatePicker && (React.createElement("div", { className: "filter-bar" },
                            React.createElement("h3", null, "End Date: "),
                            React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date *", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                            React.createElement("div", { style: { display: "flex", marginTop: "1em" } },
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd, style: { marginRight: "1em" } }, "Today"),
                                React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear")))))))),
            title && (React.createElement("div", { className: "filter-bar__title" },
                React.createElement("div", { className: "filter-bar__title-text" }, title),
                this.props.children)),
            React.createElement("div", { style: { display: "flex" } },
                React.createElement("div", { className: "filter-bar__search" },
                    React.createElement(text_field_1.MaterialTextField, { label: label, value: (_a = this.props.filterText) !== null && _a !== void 0 ? _a : "", onChange: this.handleSearch }),
                    withDatePicker && (React.createElement("div", { className: "filter-bar__date-filter" },
                        React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "", value: this.props.filterDate || "", onChange: this.handleDatePickerChange }),
                        React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickToday }, "Today"),
                        React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClear }, "Clear"),
                        !hideAdvancedFilter && (React.createElement(React.Fragment, null,
                            React.createElement(material_ui_1.IconButton, { color: "secondary", "aria-label": "Claim Filter", size: "large", component: "span", onClick: this.filterClick },
                                React.createElement(filter_1.FilterIcon, null)),
                            store_1.ordersStore.isClaim && (React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClearFilter }, "Clear Filter"))))))),
                countFilter &&
                    React.createElement("div", { className: "filter-header__action" },
                        React.createElement(material_ui_1.IconButton, { color: "secondary", "aria-label": "Claim Filter", size: "large", component: "span", onClick: this.props.handleToggle3 },
                            React.createElement(filter_1.FilterIcon, null))))));
    }
};
__decorate([
    mobx_1.observable
], FilterBar.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "cashClaimsOnly", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "showDisabledSites", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "claimStatus", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "filteredClaimsOrder", void 0);
__decorate([
    mobx_1.observable
], FilterBar.prototype, "orderClaimsRow", void 0);
__decorate([
    mobx_1.computed
], FilterBar.prototype, "availableOptions", null);
FilterBar = __decorate([
    mobx_react_1.observer
], FilterBar);
exports.FilterBar = FilterBar;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/filter-bar/filter-bar.tsx
// module id = 3359
// module chunks = 0